<div class="dialog-container">
  <div class="dialog-header">
    <div class="dialog-header-title">{{ 'PRESETS' | fallbackTranslate }}</div>
    <div class="dialog-header-cross" (click)="cancelClicked()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>

  <nz-tabset nzTabBarGutter="1" nzSize="small">
    <ng-container *ngFor="let tab of tabsGroup; let idx = index">
      <nz-tab [nzTitle]="tab?.label" (nzClick)="changeTab(idx)">
        <ng-content *ngTemplateOutlet="discountContainer"></ng-content>
      </nz-tab>
    </ng-container>
  </nz-tabset>

  <ng-template #discountContainer>
    <ng-container *ngIf="!isLoading">
      <nz-input-group [nzPrefix]="prefixIconSearch">
        <input
          type="text"
          nz-input
          nzSize="large"
          (ngModelChange)="searchQueryChange($event)"
          [placeholder]="
            'PLACEHOLDERS.SEARCH_FOR_PRESET_DISCOUNT' | fallbackTranslate
          "
        />
      </nz-input-group>
      <ng-template #prefixIconSearch>
        <i class="fa fa-search" aria-hidden="true" style="opacity: 0.6"></i>
      </ng-template>
      <div class="discount-container" *ngIf="allPresetCouponsList?.length">
        <div
          class="discount-card-grid"
          [ngClass]="currentId === all ? 'recommended-grid' : null"
        >
          <ng-container *ngFor="let item of allPresetCouponsList">
            <div
              class="discount-card flex_column flex-center gap-1"
              *ngIf="currentId !== all"
              (click)="discountClicked(item?.id, item?.data?.restaurant_id)"
              [ngClass]="{
                'discount-card-selected':
                  selectedDiscount &&
                  selectedDiscount[currentId]?.includes(item?.id),
                'disable-coupon-card': !item?.is_coupon_applicable
              }"
            >
              <div>{{ item?.data?.code }}</div>
              <div class="recommended-save">
                {{ 'POS.SAVE' | fallbackTranslate }} {{Currency}} {{ item?.total_discount_on_cart_text }}
              </div>
              <div class="waring-red fs-12" *ngIf="!item?.is_coupon_applicable">
                *{{ item?.add_more_amount_to_apply_text }}
              </div>
            </div>
            <div
              class="discount-card-recommended flex flex_column gap-1"
              *ngIf="currentId === all"
              (click)="discountClicked(item?.id, item?.data?.restaurant_id)"
              [ngClass]="{
                'discount-card-selected-recommended':
                  selectedDiscount &&
                  selectedDiscount[currentId]?.includes(item?.id),
                'disable-coupon-card': !item?.is_coupon_applicable
              }"
            >
              <div class="flex_sb">
                <div class="recommended-rest-name">
                  {{ item?.rest_name }}
                </div>
                <div class="flex gap-3 flex-center recommended-right">
                  <div class="recommended-save">
                    {{ 'POS.SAVE' | fallbackTranslate }} {{Currency}} {{ item?.total_discount_on_cart_text }}
                  </div>
                  <div class="recommended-name">
                    {{ item?.data?.code }}
                  </div>
                </div>
              </div>
              <div class="waring-red" *ngIf="!item?.is_coupon_applicable">
                *{{ item?.add_more_amount_to_apply_text }}
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <nz-skeleton [nzActive]="true" *ngIf="isLoading"></nz-skeleton>
  </ng-template>
  <ng-container *ngIf="!allPresetCouponsList?.length">
    <nz-empty [nzNotFoundContent]="contentCustom">
      <ng-template #contentCustom>
        <span>{{ 'NO COUPONS' | fallbackTranslate }}</span>
      </ng-template>
    </nz-empty>
  </ng-container>

  <div class="dialog-footer flex_sb p-2 gap-5">
    <button
      *ngIf="
        allPresetCouponsList?.length &&
        !isLoading &&
        currentId === all &&
        showSelectAll
      "
      class="save select"
      (click)="selectAll()"
    >
      {{ (selectAllChecked ? 'POS.REMOVE_ALL' : 'POS.SELECT_ALL') | fallbackTranslate }}
    </button>
    <button class="save btn" [disabled]="!hasSelectedDiscount()" (click)="submit()">
      {{ 'APPLY' | fallbackTranslate }}
    </button>
  </div>
</div>
